import { PessoaBaseModel } from './../../../core/models/pessoa.model';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { EnumDataset } from '../../../core/enums/enum-dataset';
import { getEnumValues } from '../../../core/tools/helper.tools';
import { EnumSistemas } from '../../../core/enums/enum-sistemas';
import { SpeedDialModule } from 'primeng/speeddial';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { TitleComponent } from '../../../core/componentes/Title/title.component';
import { SistemaService } from '../service/sistema.service';
import { ListarSistemasModel } from '../models/listar-sistemas.model';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-listar-sistemas',
  templateUrl: './listar-sistemas.gestao.html',
  styleUrl: './listar-sistemas.gestao.scss',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    InputTextModule,
    FloatLabelModule,
    ReactiveFormsModule,
    DropdownModule,
    InputMaskModule,
    SpeedDialModule,
    TableModule,
    ToastModule,
    TagModule,
    TitleComponent,
    InputNumberModule
  ],
})
export class ListarSistemasGestao implements OnInit {
  public translate = inject(TranslateService);
  constructor(private formBuilder: FormBuilder, private router: Router) {}

  //#region Service
  sistemaService = inject(SistemaService);
  //#endregion

  //#region Inicialização
  token: string = sessionStorage.getItem(EnumDataset.dataSetLogin) || '';
  value: string = '';
  filtroForm: FormGroup = this.initFormulario();
  sistemasConst = getEnumValues(EnumSistemas);
  sistemas: ListarSistemasModel[] = [];

  initFormulario() {
    this.filtroForm = this.formBuilder.group({
      id : null,
      nome: [''],
      sistema: ['']
    });

    return this.filtroForm;
  }

  ngOnInit() {
    this.buscarSistemas();
  }

  buscarSistemas() {
    const filtros = this.filtroForm.value;
    // Dados iniciais (seu mock de exemplo)
    this.sistemaService.buscarSistemas(filtros).then((data) => {
      this.sistemas = data;
    });
  }

  //#endregion

  //#region Actions

  selectSistema(sistema: ListarSistemasModel) {
    this.router.navigate(['/sistema', sistema.id]);

  }
  //#endregion
}
